// extracted by mini-css-extract-plugin
export var head = "services-module--head--3-KV9";
export var head_svg = "services-module--head_svg--1NRQl";
export var shake = "services-module--shake--34RhC";
export var title = "services-module--title--3PeUZ";
export var list = "services-module--list--2oAw7";
export var jsAnimInit = "services-module--jsAnimInit--1ia-Q";